export const pathBreakerModule = {
  name: 'Path Breaker',
};
